import React from 'react'
import Svg from './Svg'
export const SvgChevronLeft = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M9.178 11.996l9.441-9.441L16.065 0 4.068 11.996 16.069 24l2.553-2.556z" />
  </Svg>
))
SvgChevronLeft.isIcon = true
export default SvgChevronLeft
